if(!customElements.get('recommended-products')){
    class RecommendedProducts extends HTMLElement {
        constructor(){
            super();

            this.fetchURL = this.dataset.url;
        }

        connectedCallback(){
            const handleIntersection = (entries, observer) => {
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);

                if(!this.fetchURL) return;
                fetch(this.fetchURL)
                .then(res => res.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;

                    const complementaryProducts = html.querySelector('recommended-products');

                    if(complementaryProducts && complementaryProducts.innerHTML.trim().length){
                        this.innerHTML = complementaryProducts.innerHTML;
                    }

                    this.swiperContainer = this.querySelector(".swiper-container:not(.swiper-container--product-card)");
                    this.initializeSwiper();
                }).catch(e => {
                    console.error(e);
                });
            }

            new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 0px 0px'}).observe(this);
        }

        async initializeSwiper(){
            this.slides = this.swiperContainer.querySelectorAll('.swiper-slide:not(.swiper-slide--product-card)');
            if (!this.swiperContainer || this.slides.length <= 1) return;

            if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }

            const itemsPerView = parseInt(this.swiperContainer.dataset.itemsPerView);
            const itemsPerViewMobile = parseInt(this.swiperContainer.dataset.itemsPerViewMobile);
            const totalSlides = parseInt(this.swiperContainer.dataset.itemsTotal);

            const autoplay = this.swiperContainer.dataset.autoplay === 'true';
            const speed = parseInt(this.swiperContainer.dataset.speed);
            const loop = this.swiperContainer.dataset.loop === 'true';
            const visibleItemsPerView = (itemsPerView && totalSlides > itemsPerView)? itemsPerView : totalSlides;
            const spaceBetween = parseInt(this.swiperContainer.dataset.gap);

            const breakpoints = {
                0: { slidesPerView: itemsPerViewMobile },
                567: { slidesPerView:  visibleItemsPerView < 2? visibleItemsPerView : 2},
                768: { slidesPerView: visibleItemsPerView < 3? visibleItemsPerView : 3 },
                1200: { slidesPerView: visibleItemsPerView }
            }

            var swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                spaceBetween: 0,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                breakpoints: breakpoints,
                observer: true,
                observeSlideChildren: true,
                watchSlidesProgress: true,
                autoHeight: false,
                spaceBetween: spaceBetween,
                on: {
                     init: () => {
                       const paginationBullets = this.querySelectorAll(".swiper-pagination:not(.swiper-pagination--product-card) .swiper-pagination-bullet");
                        if(paginationBullets.length > 0){
                            this.style.setProperty('--pagination-width', `calc(100% / ${paginationBullets.length})`);
                            paginationBullets.forEach((item, index) => {
                                item.setAttribute('data-index', `${index}`);
                            });
                            setTimeout(() => {
                                this.querySelector('.swiper-pagination:not(.swiper-pagination--product-card)')?.classList.add('loaded');
                                this.checkSwiperLock();
                            }, 500);
                        }
                    },
                    slideChange: () => {
                        const activePagination = this.querySelector(".swiper-pagination:not(.swiper-pagination--product-card) .swiper-pagination-bullet-active");
                        if(activePagination){
                            const activePaginationIndex = parseInt(activePagination.dataset.index);
                            this.style.setProperty('--pagination-translate-x', `calc(100% * ${activePaginationIndex})`);
                        }
                    }
                }
            }

            if(this.swiperContainer.querySelector(".swiper-navigation-wrapper:not(.swiper-navigation-wrapper--product-card)")){
                swiperSettings.navigation = {
                    nextEl: this.swiperContainer?.querySelector('.button-next:not(.button-next--product-card)'),
                    prevEl: this.swiperContainer?.querySelector('.button-previous:not(.button-previous--product-card)')
                }
            }

             if(this.querySelector('.swiper-pagination:not(.swiper-pagination--product-card)')){
                swiperSettings.pagination = {
                    el: this.querySelector('.swiper-pagination:not(.swiper-pagination--product-card)')
                }
            }

            if(autoplay && !isNaN(speed)){
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();

            this.swiper.on("resize", () => {
                this.checkSwiperLock();
            });

            this.setupFocusListeners();
        }

        checkSwiperLock(){
            if(!this.querySelector(".swiper-pagination:not(.swiper-pagination--product-card)")) return;
            
            if(this.swiper.isLocked){
                this.querySelector(".swiper-pagination:not(.swiper-pagination--product-card)").classList.add('hidden');
            }else{
                this.querySelector(".swiper-pagination:not(.swiper-pagination--product-card)").classList.remove('hidden');
            }
        }

        setupFocusListeners(){
            this.querySelectorAll(".button-next:not(.button-next--product-card), .button-previous:not(.button-previous--product-card)").forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');
                    button.addEventListener('blur', () => {
                        button.classList.remove('focused');
                    }, { once: true });
                });
            });
        }
    }

    customElements.define('recommended-products', RecommendedProducts);
}